import { useMemo } from "react";

import SpecDetailCom from "../../../../models/SpecDetailCom";
import { usePerformRetrieveList } from "../../../hooks/usePerformRetrieveList";

export const deleteSpecDetailComsDataComponentId =
  "deleteSpecDetailComsDataComponentId";
const dataComponent = {
  model: SpecDetailCom,
  apiRoute: "spec-detail-coms",
  includes: [],
  dataComponentId: deleteSpecDetailComsDataComponentId,
};
const useListSpecDetailComs = specIdsString => {
  const specIds = useMemo(() => specIdsString.split(",").filter(Boolean), [
    specIdsString,
  ]);
  const hasSpecIds = specIds.length > 0;
  const filters = useMemo(
    () => ({
      rootFilters: {
        $where: {
          specId: {
            $in: specIds,
          },
        },
      },
      pageSize: -1,
    }),
    [specIds]
  );
  const memoDataComponent = useMemo(() => dataComponent, []);
  const { data, isLoading } = usePerformRetrieveList(
    memoDataComponent,
    filters,
    undefined,
    !hasSpecIds
  );

  return {
    comSpecDetailIdSet: new Set(
      hasSpecIds ? data.map(({ specId }) => String(specId)) : []
    ),
    isLoading: hasSpecIds && isLoading,
  };
};

export default useListSpecDetailComs;
